module.exports = __webpack_public_path__ + "img/vertical.9fe218f5.png";